import React from "react";

import {
  cn,
  FALLBACK_COMMERCE_IMAGE,
} from "../utils/commercesUtils";

export default function CommerceAdaptiveImage({
  src,
  alt,
  className = "",
  imageClassName = "",
  rounded = "",
  withOverlay = true,
}) {
  const image = src || FALLBACK_COMMERCE_IMAGE;

  return (
    <div
      className={cn(
        "relative isolate overflow-hidden bg-slate-100 dark:bg-slate-900",
        rounded,
        className
      )}
    >
      <img
        src={image}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full scale-110 object-cover opacity-35 blur-xl"
        onError={(event) => {
          event.currentTarget.src = FALLBACK_COMMERCE_IMAGE;
        }}
      />

      <div className="absolute inset-0 bg-white/15 dark:bg-slate-950/15" />

      <img
        src={image}
        alt={alt}
        loading="lazy"
        className={cn(
          "relative z-10 h-full w-full object-contain transition duration-500 group-hover:scale-[1.02]",
          imageClassName
        )}
        onError={(event) => {
          event.currentTarget.src = FALLBACK_COMMERCE_IMAGE;
        }}
      />

      {withOverlay && (
        <div className="pointer-events-none absolute inset-0 z-20 bg-gradient-to-t from-slate-950/60 via-slate-950/10 to-transparent" />
      )}
    </div>
  );
}